import { render, staticRenderFns } from "./ChartAccountHelper.vue?vue&type=template&id=36974101&scoped=true"
import script from "./ChartAccountHelper.vue?vue&type=script&lang=js"
export * from "./ChartAccountHelper.vue?vue&type=script&lang=js"
import style0 from "./ChartAccountHelper.vue?vue&type=style&index=0&id=36974101&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36974101",
  null
  
)

export default component.exports